import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["updatedBy", "sourceApp", "internalJobUpdateTime"],
  _excluded2 = ["updatedBy"];
import UpdateMetadataUser from 'automation-ui-canvas/flow/records/properties/UpdateMetadataUser';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { WORKFLOWS_APP } from 'automation-ui-source-apps/constants/SourceApps';
export default class UpdateMetadata extends createImmutableObjectClass({
  cloneMetadata: null,
  updatedBy: null,
  updatedAt: 0,
  referrer: null,
  originRequestId: null,
  integrationId: null,
  jobName: null,
  templateMetadata: null,
  sourceApp: WORKFLOWS_APP,
  internalJobUpdateTime: undefined
}, {
  fromJSON: _ref => {
    let {
        updatedBy,
        sourceApp
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return Object.assign({}, rest, {
      updatedBy: updatedBy ? new UpdateMetadataUser(updatedBy) : null,
      sourceApp: sourceApp
    });
  },
  toJSON: _ref2 => {
    let {
        updatedBy
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return Object.assign({
      updatedBy: updatedBy && updatedBy.toJSON()
    }, rest);
  }
}) {
  getSourceApp() {
    return this.sourceApp;
  }
  getCloneMetadata() {
    return this.cloneMetadata;
  }
  getTemplaMetadata() {
    return this.templateMetadata;
  }
  getUpdatedBy() {
    return this.updatedBy;
  }
  getUpdatedAt() {
    return this.updatedAt;
  }
}